import PropTypes from 'prop-types';

import CustomRoute from '../CustomRoute';

const InnerRoutes = ({ route }) => {
  return (
    route.routes?.map((r) => (
      <CustomRoute key={r.key} {...r} component={r.component} />
    )) || null
  );
};

InnerRoutes.propTypes = {
  route: PropTypes.object.isRequired,
};

export default InnerRoutes;
